import { FC } from "react";
import { HorizontalTab } from "@/components/HorizontalTab";
import { Blocks, BuilderBlock } from "@builder.io/sdk-react";
import { BuilderProps } from "@/types/builder/BuilderProps";

type HorizontalTabBlockProps = {
  tabs: {
    label: string;
    dlt: string;
    dld: string;
    tabContent: BuilderBlock[];
  }[];
  initialActiveTab?: number;
  theme?: "black" | "gray" | "white";
  children?: React.ReactNode;
} & BuilderProps;

export const HorizontalTabBlock: FC<HorizontalTabBlockProps> = ({
  tabs,
  initialActiveTab,
  theme,
  builderBlock,
  builderComponents,
  builderContext,
  builderLinkComponent,
  children,
}) => {
  return (
    <HorizontalTab
      tabs={tabs?.map((tab, index) => ({
        label: tab.label,
        dlt: tab.dlt,
        dld: tab.dld,
        tabContent: (
          <Blocks
            key={builderBlock?.id}
            parent={builderBlock?.id}
            registeredComponents={builderComponents}
            context={builderContext}
            path={`tabs.${index}.tabContent`}
            blocks={tab.tabContent}
            linkComponent={builderLinkComponent}
            className="h-full"
          />
        ),
      }))}
      initialActiveTab={initialActiveTab || 0}
      theme={theme}
    >
      {children}
    </HorizontalTab>
  );
};
